var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyIncomeRafiki(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.78,
    y: 215.26,
    width: 22.4,
    height: 167.01,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.12,
    y: 158.31,
    width: 22.4,
    height: 223.96,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.46,
    y: 215.26,
    width: 22.4,
    height: 167.01,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.1,
    y: 272.2,
    width: 22.4,
    height: 110.06,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.44,
    y: 244.71,
    width: 22.4,
    height: 137.56,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.8,
    y: 272.2,
    width: 22.4,
    height: 110.06,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.49,
    y: 101.36,
    width: 22.4,
    height: 280.9,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.14,
    y: 215.26,
    width: 22.4,
    height: 167.01,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.15,
    y: 158.31,
    width: 22.4,
    height: 223.96,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.82,
    y: 187.76,
    width: 22.4,
    height: 194.51,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.48,
    y: 244.71,
    width: 22.4,
    height: 137.56,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.61 153.54 356.63 172.32 397.72 142.68 409.7 105.92 431.56 86.7 436.63 92.49 448.1 64.36 415.44 66.04 421.23 72.59 399.27 91.4 388.34 128.49 348.61 153.54",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.21,
    cy: 201.42,
    r: 15.63,
    transform: "translate(-148.11 215.7) rotate(-76.72)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.09,
    cy: 201.42,
    r: 15.63,
    transform: "translate(-123.66 104.31) rotate(-45)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.09,
    cy: 201.42,
    r: 11.7,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.23,203.91c.45,2.59-1.33,4.32-4.53,4.59l0,2.14h-2l.06-2.14A10.74,10.74,0,0,1,58,207l.88-2.41A8.88,8.88,0,0,0,62.82,206l.09-3.28c-1.91-.55-4-1.27-4.43-3.62-.45-2.59,1.36-4.33,4.63-4.57l0-2.14h2l0,2.16a9.91,9.91,0,0,1,3.77,1.11L68.06,198A7.48,7.48,0,0,0,65,197l-.08,3.42C66.79,201,68.84,201.68,69.23,203.91Zm-6.26-4,.07-2.8c-1.07.21-1.59.81-1.48,1.55S62.21,199.61,63,199.91Zm3.2,4.51c-.1-.57-.61-.92-1.34-1.17l0,2.66C65.79,205.7,66.3,205.16,66.17,204.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.05,121.19c5.49,11.73-1.88,23.41-12.5,27.87a19.2,19.2,0,0,1-26-11.72c-3.72-10.93.15-28.49,10.77-32.95C165.36,104.39,185.81,105.74,193.05,121.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.38,127.71c1.69,2.54.6,5.17-2.69,6.9l.94,2.29-2.08.87-.94-2.29a12.53,12.53,0,0,1-5.76.53l-.18-2.95a10.52,10.52,0,0,0,4.83-.29l-1.45-3.52c-2.29.27-4.88.46-6.42-1.85-1.69-2.54-.57-5.21,2.81-6.93l-.94-2.29,2.07-.87,1,2.31a11.46,11.46,0,0,1,4.55-.52l.31,2.9a9,9,0,0,0-3.76.31l1.51,3.67C177.4,125.69,179.91,125.51,181.38,127.71Zm-8.57-1.44-1.23-3c-1,.71-1.31,1.58-.85,2.31A2.24,2.24,0,0,0,172.81,126.27Zm5.53,3.35a2,2,0,0,0-2-.64l1.19,2.85C178.54,131.15,178.83,130.35,178.34,129.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.94,108.32l-5.38-5s.6-4.82,3.53-6.24a5.77,5.77,0,0,1,5.18-.14l5.39-4,.9,12.3S165.81,111.91,159.94,108.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,105.57c-1.33-2.19-2.6-4.46-3.92-6.66a3.29,3.29,0,0,0-3,.38,3.5,3.5,0,0,0-1.44,2.69,24.31,24.31,0,0,0,4.13,5C162,106.06,165.28,105.07,166,105.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.06,105.47l-1-7.38c-.33.37-.56.7-.89,1.07.31,1.5,1.22,6,1.37,6.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.44,202.63c-16.63,10.08-33.38-9.88-50,.2q0-13.9-.11-27.81c16.63-10.08,33.38,9.88,50-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.19,199.44l-.08-19.06a1.41,1.41,0,0,1-2.14-1.32c-13.73,4.36-27.53-8.15-41.27-3.79a3.52,3.52,0,0,1-2.12,2.94l.08,19.07a1.4,1.4,0,0,1,2.13,1.31c13.74-4.36,27.54,8.16,41.28,3.8A3.52,3.52,0,0,1,308.19,199.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.16,186.88a.77.77,0,0,0,.2.49,2.66,2.66,0,0,0,.58.45c0-.5,0-1,0-1.49a.86.86,0,0,0-.58.13A.5.5,0,0,0,284.16,186.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,189.93v1.44a.83.83,0,0,0,.56-.11.43.43,0,0,0,.19-.39.79.79,0,0,0-.19-.49A2.36,2.36,0,0,0,286,189.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35,181c-4.31-1.33-7.79,1.38-7.78,5.71s3.53,8.56,7.84,9.89,7.8-1.38,7.78-5.72S289.67,182.36,285.35,181Zm2.46,11.49a2.37,2.37,0,0,1-1.8.23v1.17l-1.05-.31v-1.14a7.42,7.42,0,0,1-1.48-.7,5.49,5.49,0,0,1-1.13-.89l.57-1.11a6,6,0,0,0,.93.76,6.07,6.07,0,0,0,1.1.57v-1.74a12.5,12.5,0,0,1-1.26-.77,3.63,3.63,0,0,1-.86-.89,2.19,2.19,0,0,1-.35-1.23,1.47,1.47,0,0,1,.62-1.31,2.46,2.46,0,0,1,1.83-.22c0-.38,0-.77,0-1.16l1.05.31v1.14a6.55,6.55,0,0,1,2.12,1.26l-.51,1.13a5.89,5.89,0,0,0-1.61-1c0,.59,0,1.19,0,1.78a10.1,10.1,0,0,1,1.24.75,3.43,3.43,0,0,1,.86.88,2.23,2.23,0,0,1,.35,1.21A1.45,1.45,0,0,1,287.81,192.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.34,198c-16.62,10.08-33.37-9.88-50,.2q-.06-13.91-.11-27.81c16.62-10.08,33.37,9.88,50-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.09,194.85,312,175.78a1.39,1.39,0,0,1-2.13-1.31c-13.74,4.36-27.54-8.15-41.28-3.8a3.52,3.52,0,0,1-2.12,3l.08,19.06a1.4,1.4,0,0,1,2.13,1.32c13.74-4.36,27.54,8.15,41.28,3.79A3.5,3.5,0,0,1,312.09,194.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.06,182.29a.73.73,0,0,0,.2.48,3,3,0,0,0,.58.46v-1.49a.89.89,0,0,0-.59.13A.51.51,0,0,0,288.06,182.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.9,185.33v1.45a.87.87,0,0,0,.57-.11.46.46,0,0,0,.18-.39.72.72,0,0,0-.19-.49A2.81,2.81,0,0,0,289.9,185.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.25,176.43c-4.31-1.33-7.79,1.39-7.77,5.72s3.52,8.55,7.84,9.88,7.79-1.38,7.77-5.71S293.57,177.76,289.25,176.43Zm2.47,11.5a2.44,2.44,0,0,1-1.81.23v1.17l-1.05-.31v-1.14a7.46,7.46,0,0,1-1.48-.71,5.43,5.43,0,0,1-1.13-.89l.57-1.11a5.4,5.4,0,0,0,.93.76,6.13,6.13,0,0,0,1.1.58v-1.75a11,11,0,0,1-1.26-.76,3.5,3.5,0,0,1-.86-.9,2.14,2.14,0,0,1-.35-1.22,1.5,1.5,0,0,1,.63-1.31,2.37,2.37,0,0,1,1.82-.22v-1.16l1,.31v1.14A6.33,6.33,0,0,1,292,181.9c-.18.38-.35.75-.52,1.13a5.89,5.89,0,0,0-1.61-1c0,.59,0,1.18,0,1.78a10.14,10.14,0,0,1,1.24.74,3.31,3.31,0,0,1,.86.89,2.15,2.15,0,0,1,.35,1.21A1.48,1.48,0,0,1,291.72,187.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-64"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-64",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.88,408.12v2.08a2,2,0,0,0,2,1.95h74.55a1.8,1.8,0,0,0,1.8-1.8v-2a1.8,1.8,0,0,0-1.8-1.8H189.84a3.39,3.39,0,0,1-3.34-4L193,365H150.65l-18.13,40.13A7.34,7.34,0,0,0,131.88,408.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.18,408.34v2a1.79,1.79,0,0,1-1.79,1.8H133.83a2,2,0,0,1-2-1.95v-2.08a7.57,7.57,0,0,1,.19-1.64,7.26,7.26,0,0,1,.46-1.36L150.65,365H193l-6.51,37.57a2.94,2.94,0,0,0-.05.66,3.4,3.4,0,0,0,2.69,3.24,3.29,3.29,0,0,0,.71.07h18.54A1.79,1.79,0,0,1,210.18,408.34Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.13,405.13,148.26,365h2.39l-18.13,40.13a7.34,7.34,0,0,0-.64,3v2.08a2,2,0,0,0,2,1.95h-2.4a2,2,0,0,1-2-1.95v-2.08A7.19,7.19,0,0,1,130.13,405.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.65 365 193 365 191.34 374.59 146.32 374.59 150.65 365",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.46,369.22H85.78a7.35,7.35,0,0,1-7.18-6.61L67.17,232.05a6,6,0,0,1,6-6.61H253.88a7.34,7.34,0,0,1,7.18,6.61l11.43,130.56A6,6,0,0,1,266.46,369.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,348.49l1.24,14.12a6,6,0,0,1-6,6.61H85.78a7.34,7.34,0,0,1-7.18-6.61l-1.24-14.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,348.49l1.24,14.12a6,6,0,0,1-6,6.61H85.78a7.34,7.34,0,0,1-7.18-6.61l-1.24-14.12",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.74,344.5H264.18a3.23,3.23,0,0,0,3.27-3.58L258,233a4,4,0,0,0-3.9-3.58H73.67A3.23,3.23,0,0,0,70.4,233l9.44,107.91A4,4,0,0,0,83.74,344.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.74,344.5H264.18a3.23,3.23,0,0,0,3.27-3.58L258,233a4,4,0,0,0-3.9-3.58H73.67A3.23,3.23,0,0,0,70.4,233l9.44,107.91A4,4,0,0,0,83.74,344.5Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.21,225.44h4a6,6,0,0,0-6,6.61L78.6,362.61a7.34,7.34,0,0,0,7.18,6.61h-4a7.36,7.36,0,0,1-7.18-6.61L63.18,232.05A6,6,0,0,1,69.21,225.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.21,225.44h4a6,6,0,0,0-6,6.61L78.6,362.61a7.34,7.34,0,0,0,7.18,6.61h-4a7.36,7.36,0,0,1-7.18-6.61L63.18,232.05A6,6,0,0,1,69.21,225.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.15,250.8a9.37,9.37,0,0,1-9.56,9.51H141.25a11.62,11.62,0,0,1-11.35-10.44c0-.31,0-.63,0-.93a9.39,9.39,0,0,1,9.56-9.51h54.34a11.61,11.61,0,0,1,11.35,10.44C205.14,250.18,205.15,250.49,205.15,250.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.91,250.8a9.38,9.38,0,0,1-9.56,9.51h-52.1a11.62,11.62,0,0,1-11.35-10.44c0-.31,0-.63,0-.93a9.39,9.39,0,0,1,9.56-9.51h52.1a11.61,11.61,0,0,1,11.35,10.44C202.9,250.18,202.91,250.49,202.91,250.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.93,300.82l.11,1.31h-1l-.11-1.3a5.53,5.53,0,0,1-3-1l.43-1.19a4.94,4.94,0,0,0,2.42.9l-.21-2.35c-1.33-.32-2.76-.74-2.9-2.37-.1-1.19.67-2.23,2.48-2.41l-.11-1.32h1l.11,1.3a5.27,5.27,0,0,1,2.44.71l-.37,1.19a5.18,5.18,0,0,0-2-.64l.21,2.37c1.33.32,2.78.73,2.93,2.35C138.54,299.6,137.75,300.63,135.93,300.82Zm-1.4-5-.18-2.08c-.82.13-1.14.55-1.09,1.06S133.83,295.6,134.53,295.8Zm2.41,2.71c-.05-.57-.59-.84-1.31-1l.19,2.07C136.66,299.41,137,299,136.94,298.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.31,298.21c.13,1.44-.81,2.63-3,2.63a5.5,5.5,0,0,1-3.17-.95l.54-1.18a4.21,4.21,0,0,0,2.49.81c1.09,0,1.69-.48,1.62-1.26s-.61-1.27-2.31-1.27h-2l0-4.47h4.81l.12,1.28h-3.53v1.9h.78C144.12,295.7,145.18,296.75,145.31,298.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.06,296.62c-.24-2.69,1.1-4.21,3.05-4.21s3.57,1.52,3.8,4.21-1.11,4.22-3.06,4.22S146.29,299.32,146.06,296.62Zm5.32,0c-.18-2-1-2.89-2.16-2.89s-1.8.91-1.63,2.89,1,2.9,2.14,2.9S151.55,298.6,151.38,296.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,296.62c-.24-2.69,1.1-4.21,3.05-4.21s3.57,1.52,3.8,4.21-1.11,4.22-3.06,4.22S154.18,299.32,154,296.62Zm5.32,0c-.18-2-1-2.89-2.15-2.89s-1.81.91-1.64,2.89,1,2.9,2.14,2.9S159.44,298.6,159.27,296.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.84,296.62c-.24-2.69,1.1-4.21,3-4.21s3.57,1.52,3.8,4.21-1.11,4.22-3.06,4.22S162.07,299.32,161.84,296.62Zm5.32,0c-.18-2-1-2.89-2.15-2.89s-1.81.91-1.64,2.89,1,2.9,2.14,2.9S167.33,298.6,167.16,296.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.74,299.83a2.28,2.28,0,0,1-.18,1l-.45,1.65h-1l.31-1.79a1,1,0,0,1-.63-.87.84.84,0,0,1,.87-1A1,1,0,0,1,171.74,299.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.31,296.62c-.24-2.69,1.1-4.21,3.05-4.21s3.57,1.52,3.8,4.21-1.11,4.22-3.06,4.22S172.54,299.32,172.31,296.62Zm5.32,0c-.18-2-1-2.89-2.15-2.89s-1.81.91-1.64,2.89,1,2.9,2.14,2.9S177.8,298.6,177.63,296.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.2,296.62c-.24-2.69,1.11-4.21,3.05-4.21s3.57,1.52,3.8,4.21-1.1,4.22-3.06,4.22S180.43,299.32,180.2,296.62Zm5.32,0c-.18-2-1-2.89-2.15-2.89s-1.81.91-1.64,2.89,1,2.9,2.14,2.9S185.69,298.6,185.52,296.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.89,297.15l-.41-4.63H193l.4,4.57c.15,1.69,1,2.42,2.3,2.42s2-.73,1.86-2.42l-.4-4.57h1.5l.41,4.63c.21,2.39-1,3.69-3.26,3.69A3.66,3.66,0,0,1,191.89,297.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.75,299.86l.43-1.19a4.86,4.86,0,0,0,2.78.91c1.28,0,1.78-.46,1.72-1.07-.15-1.77-4.92-.61-5.19-3.66-.12-1.32.84-2.44,3.09-2.44a5.49,5.49,0,0,1,2.79.72l-.37,1.19a4.84,4.84,0,0,0-2.32-.65c-1.27,0-1.74.49-1.68,1.11.15,1.75,4.91.61,5.17,3.62.12,1.32-.85,2.44-3.1,2.44A5.71,5.71,0,0,1,200.75,299.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.18,292.52h3.58a4.53,4.53,0,0,1,4.84,4.1c.21,2.46-1.46,4.11-4.12,4.11h-3.59Zm4.12,6.92a2.48,2.48,0,0,0,2.76-2.82,3,3,0,0,0-3.26-2.81h-2l.49,5.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.63,299.83a.85.85,0,0,1,.88-1,1,1,0,0,1,1,1,.86.86,0,0,1-.87,1A1.06,1.06,0,0,1,217.63,299.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153,246.11l-1.74,7.16h-1.41l-2.24-5.3-1.33,5.3h-1.42l-3-7.16h1.38l2.25,5.44,1.38-5.44h1.23l2.28,5.48,1.36-5.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.87,246.14a.7.7,0,0,1,.75-.77.85.85,0,0,1,.88.74.71.71,0,0,1-.75.8A.86.86,0,0,1,153.87,246.14Zm.32,1.67h1.27l.48,5.46h-1.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.88,253a1.92,1.92,0,0,1-1.2.36,1.85,1.85,0,0,1-2-1.84l-.23-2.63h-.9l-.09-1h.9l-.11-1.25h1.28l.11,1.25h1.46l.09,1h-1.46l.22,2.6a.78.78,0,0,0,.83.82,1.09,1.09,0,0,0,.7-.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.06,250.14l.28,3.13h-1.28l-.26-3c-.09-1-.61-1.45-1.43-1.45s-1.47.56-1.38,1.65l.24,2.76H162l-.67-7.59h1.28l.24,2.76a2.23,2.23,0,0,1,1.76-.69A2.35,2.35,0,0,1,167.06,250.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7,245.68l.66,7.59h-1.23l-.06-.7a2,2,0,0,1-1.74.77,3,3,0,0,1-3-2.8,2.55,2.55,0,0,1,4.34-2l-.24-2.81Zm-.84,4.86a1.77,1.77,0,0,0-1.77-1.71,1.45,1.45,0,0,0-1.48,1.71,1.77,1.77,0,0,0,1.78,1.71A1.43,1.43,0,0,0,172.86,250.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.72,247.75l.1,1.22a1.77,1.77,0,0,0-.3,0c-1,0-1.53.58-1.44,1.69l.24,2.65H176l-.48-5.46h1.22l.07.8A1.94,1.94,0,0,1,178.72,247.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.54,250.07l.28,3.2h-1.2l-.06-.66a1.78,1.78,0,0,1-1.66.73,2,2,0,0,1-2.17-1.63c-.08-.91.47-1.63,2.12-1.63h1.42V250c-.07-.75-.56-1.19-1.47-1.19a2.51,2.51,0,0,0-1.6.54l-.59-.93a3.61,3.61,0,0,1,2.26-.67A2.36,2.36,0,0,1,184.54,250.07Zm-1.14,1.49-.06-.63H182c-.87,0-1.08.33-1,.73s.45.75,1.11.75A1.26,1.26,0,0,0,183.4,251.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4,247.81l-1.54,5.46h-1.23l-1.74-3.76-1.1,3.76h-1.23l-2.48-5.46h1.21l1.79,4,1.15-4h1.08l1.83,4.05,1.12-4.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.67,283.57l.25,2.89H136.4l-.26-2.87-3.68-5.33h1.62l2.76,4,2.07-4h1.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5,283.33a2.84,2.84,0,0,1,3-3.2,3.49,3.49,0,0,1,3.62,3.2,2.84,2.84,0,0,1-3,3.21A3.5,3.5,0,0,1,140.5,283.33Zm5.19,0a2,2,0,0,0-2-1.95,1.65,1.65,0,0,0-1.68,1.95,2,2,0,0,0,2,2A1.65,1.65,0,0,0,145.69,283.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36,280.2l.55,6.26h-1.4l-.07-.79a2.34,2.34,0,0,1-1.94.87,2.73,2.73,0,0,1-2.93-2.76l-.32-3.58h1.47l.29,3.38c.1,1.14.69,1.67,1.61,1.67s1.66-.63,1.55-1.88l-.28-3.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,280.13l.12,1.4a1.48,1.48,0,0,0-.34,0c-1.11,0-1.76.66-1.65,1.94l.27,3h-1.47l-.54-6.26h1.39l.08.92A2.24,2.24,0,0,1,159.9,280.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.42,278.26h1.52l.72,8.2h-1.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.58,282.88l.32,3.58h-1.47l-.3-3.4c-.09-1.11-.69-1.65-1.63-1.65s-1.69.63-1.58,1.89l.28,3.16h-1.47l-.55-6.26h1.4l.07.81a2.51,2.51,0,0,1,2.08-.88A2.71,2.71,0,0,1,174.58,282.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,283.33a2.87,2.87,0,0,1,3.11-3.2,3.11,3.11,0,0,1,2.8,1.46l-1.07.65a2,2,0,0,0-1.63-.86,1.66,1.66,0,0,0-1.73,1.95,2,2,0,0,0,2.07,2,1.59,1.59,0,0,0,1.48-.87l1.18.66a2.55,2.55,0,0,1-2.54,1.46A3.53,3.53,0,0,1,176,283.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.75,283.33a2.85,2.85,0,0,1,3.05-3.2,3.51,3.51,0,0,1,3.62,3.2,2.85,2.85,0,0,1-3.06,3.21A3.51,3.51,0,0,1,182.75,283.33Zm5.19,0a2,2,0,0,0-2-1.95,1.64,1.64,0,0,0-1.68,1.95,2,2,0,0,0,2,2A1.64,1.64,0,0,0,187.94,283.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.25,282.88l.32,3.58H200.1l-.3-3.4c-.09-1.11-.66-1.65-1.55-1.65s-1.57.63-1.46,1.88l.28,3.17H195.6l-.29-3.4c-.1-1.11-.67-1.65-1.56-1.65s-1.57.63-1.46,1.88l.28,3.17H191.1l-.54-6.26H192l.07.8a2.38,2.38,0,0,1,2-.87,2.55,2.55,0,0,1,2.2,1.05,2.85,2.85,0,0,1,5.06,1.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.13,283.8h-4.91a2.1,2.1,0,0,0,2.16,1.5,2,2,0,0,0,1.64-.68l.87.9a2.92,2.92,0,0,1-2.43,1,3.52,3.52,0,0,1-3.74-3.21,2.81,2.81,0,0,1,2.95-3.2,3.39,3.39,0,0,1,3.45,3.24C209.13,283.49,209.13,283.66,209.13,283.8Zm-5-1h3.55a1.9,1.9,0,0,0-1.91-1.52A1.55,1.55,0,0,0,204.13,282.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "148.06 229.43 141.11 229.43 116.66 344.5 123.6 344.5 148.06 229.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.64 344.5 134.1 229.43 108.02 229.43 83.56 344.5 109.64 344.5",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.76,408.36v1.91a1.88,1.88,0,0,0,1.88,1.88h61.75a1.8,1.8,0,0,0,1.79-1.8v-2a1.8,1.8,0,0,0-1.79-1.8H189.84a3.11,3.11,0,0,1-.69-.07H146.64A1.88,1.88,0,0,0,144.76,408.36Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.06,406.48h57.09a3.39,3.39,0,0,1-2.7-3.24H133.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.6 263.68 194.58 263.68 197.7 255.73 203.6 263.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.21 269.12 199.1 269.12 197.22 258.35 199.32 258.35 201.21 269.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.88,408.12v2.08a2,2,0,0,0,2,1.95h74.55a1.8,1.8,0,0,0,1.8-1.8v-2a1.8,1.8,0,0,0-1.8-1.8H189.84a3.39,3.39,0,0,1-3.34-4L193,365H150.65l-18.13,40.13A7.34,7.34,0,0,0,131.88,408.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.18,408.34v2a1.79,1.79,0,0,1-1.79,1.8H133.83a2,2,0,0,1-2-1.95v-2.08a7.57,7.57,0,0,1,.19-1.64,7.26,7.26,0,0,1,.46-1.36L150.65,365H193l-6.51,37.57a2.94,2.94,0,0,0-.05.66,3.4,3.4,0,0,0,2.69,3.24,3.29,3.29,0,0,0,.71.07h18.54A1.79,1.79,0,0,1,210.18,408.34Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.13,405.13,148.26,365h2.39l-18.13,40.13a7.34,7.34,0,0,0-.64,3v2.08a2,2,0,0,0,2,1.95h-2.4a2,2,0,0,1-2-1.95v-2.08A7.19,7.19,0,0,1,130.13,405.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.65 365 193 365 191.34 374.59 146.32 374.59 150.65 365",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.46,369.22H85.78a7.35,7.35,0,0,1-7.18-6.61L67.17,232.05a6,6,0,0,1,6-6.61H253.88a7.34,7.34,0,0,1,7.18,6.61l11.43,130.56A6,6,0,0,1,266.46,369.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,348.49l1.24,14.12a6,6,0,0,1-6,6.61H85.78a7.34,7.34,0,0,1-7.18-6.61l-1.24-14.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,348.49l1.24,14.12a6,6,0,0,1-6,6.61H85.78a7.34,7.34,0,0,1-7.18-6.61l-1.24-14.12",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.74,344.5H264.18a3.23,3.23,0,0,0,3.27-3.58L258,233a4,4,0,0,0-3.9-3.58H73.67A3.23,3.23,0,0,0,70.4,233l9.44,107.91A4,4,0,0,0,83.74,344.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.74,344.5H264.18a3.23,3.23,0,0,0,3.27-3.58L258,233a4,4,0,0,0-3.9-3.58H73.67A3.23,3.23,0,0,0,70.4,233l9.44,107.91A4,4,0,0,0,83.74,344.5Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.21,225.44h4a6,6,0,0,0-6,6.61L78.6,362.61a7.34,7.34,0,0,0,7.18,6.61h-4a7.36,7.36,0,0,1-7.18-6.61L63.18,232.05A6,6,0,0,1,69.21,225.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.21,225.44h4a6,6,0,0,0-6,6.61L78.6,362.61a7.34,7.34,0,0,0,7.18,6.61h-4a7.36,7.36,0,0,1-7.18-6.61L63.18,232.05A6,6,0,0,1,69.21,225.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.15,250.8a9.37,9.37,0,0,1-9.56,9.51H141.25a11.62,11.62,0,0,1-11.35-10.44c0-.31,0-.63,0-.93a9.39,9.39,0,0,1,9.56-9.51h54.34a11.61,11.61,0,0,1,11.35,10.44C205.14,250.18,205.15,250.49,205.15,250.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.91,250.8a9.38,9.38,0,0,1-9.56,9.51h-52.1a11.62,11.62,0,0,1-11.35-10.44c0-.31,0-.63,0-.93a9.39,9.39,0,0,1,9.56-9.51h52.1a11.61,11.61,0,0,1,11.35,10.44C202.9,250.18,202.91,250.49,202.91,250.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.93,300.82l.11,1.31h-1l-.11-1.3a5.53,5.53,0,0,1-3-1l.43-1.19a4.94,4.94,0,0,0,2.42.9l-.21-2.35c-1.33-.32-2.76-.74-2.9-2.37-.1-1.19.67-2.23,2.48-2.41l-.11-1.32h1l.11,1.3a5.27,5.27,0,0,1,2.44.71l-.37,1.19a5.18,5.18,0,0,0-2-.64l.21,2.37c1.33.32,2.78.73,2.93,2.35C138.54,299.6,137.75,300.63,135.93,300.82Zm-1.4-5-.18-2.08c-.82.13-1.14.55-1.09,1.06S133.83,295.6,134.53,295.8Zm2.41,2.71c-.05-.57-.59-.84-1.31-1l.19,2.07C136.66,299.41,137,299,136.94,298.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.31,298.21c.13,1.44-.81,2.63-3,2.63a5.5,5.5,0,0,1-3.17-.95l.54-1.18a4.21,4.21,0,0,0,2.49.81c1.09,0,1.69-.48,1.62-1.26s-.61-1.27-2.31-1.27h-2l0-4.47h4.81l.12,1.28h-3.53v1.9h.78C144.12,295.7,145.18,296.75,145.31,298.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.06,296.62c-.24-2.69,1.1-4.21,3.05-4.21s3.57,1.52,3.8,4.21-1.11,4.22-3.06,4.22S146.29,299.32,146.06,296.62Zm5.32,0c-.18-2-1-2.89-2.16-2.89s-1.8.91-1.63,2.89,1,2.9,2.14,2.9S151.55,298.6,151.38,296.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,296.62c-.24-2.69,1.1-4.21,3.05-4.21s3.57,1.52,3.8,4.21-1.11,4.22-3.06,4.22S154.18,299.32,154,296.62Zm5.32,0c-.18-2-1-2.89-2.15-2.89s-1.81.91-1.64,2.89,1,2.9,2.14,2.9S159.44,298.6,159.27,296.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.84,296.62c-.24-2.69,1.1-4.21,3-4.21s3.57,1.52,3.8,4.21-1.11,4.22-3.06,4.22S162.07,299.32,161.84,296.62Zm5.32,0c-.18-2-1-2.89-2.15-2.89s-1.81.91-1.64,2.89,1,2.9,2.14,2.9S167.33,298.6,167.16,296.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.74,299.83a2.28,2.28,0,0,1-.18,1l-.45,1.65h-1l.31-1.79a1,1,0,0,1-.63-.87.84.84,0,0,1,.87-1A1,1,0,0,1,171.74,299.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.31,296.62c-.24-2.69,1.1-4.21,3.05-4.21s3.57,1.52,3.8,4.21-1.11,4.22-3.06,4.22S172.54,299.32,172.31,296.62Zm5.32,0c-.18-2-1-2.89-2.15-2.89s-1.81.91-1.64,2.89,1,2.9,2.14,2.9S177.8,298.6,177.63,296.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.2,296.62c-.24-2.69,1.11-4.21,3.05-4.21s3.57,1.52,3.8,4.21-1.1,4.22-3.06,4.22S180.43,299.32,180.2,296.62Zm5.32,0c-.18-2-1-2.89-2.15-2.89s-1.81.91-1.64,2.89,1,2.9,2.14,2.9S185.69,298.6,185.52,296.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.89,297.15l-.41-4.63H193l.4,4.57c.15,1.69,1,2.42,2.3,2.42s2-.73,1.86-2.42l-.4-4.57h1.5l.41,4.63c.21,2.39-1,3.69-3.26,3.69A3.66,3.66,0,0,1,191.89,297.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.75,299.86l.43-1.19a4.86,4.86,0,0,0,2.78.91c1.28,0,1.78-.46,1.72-1.07-.15-1.77-4.92-.61-5.19-3.66-.12-1.32.84-2.44,3.09-2.44a5.49,5.49,0,0,1,2.79.72l-.37,1.19a4.84,4.84,0,0,0-2.32-.65c-1.27,0-1.74.49-1.68,1.11.15,1.75,4.91.61,5.17,3.62.12,1.32-.85,2.44-3.1,2.44A5.71,5.71,0,0,1,200.75,299.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.18,292.52h3.58a4.53,4.53,0,0,1,4.84,4.1c.21,2.46-1.46,4.11-4.12,4.11h-3.59Zm4.12,6.92a2.48,2.48,0,0,0,2.76-2.82,3,3,0,0,0-3.26-2.81h-2l.49,5.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.63,299.83a.85.85,0,0,1,.88-1,1,1,0,0,1,1,1,.86.86,0,0,1-.87,1A1.06,1.06,0,0,1,217.63,299.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153,246.11l-1.74,7.16h-1.41l-2.24-5.3-1.33,5.3h-1.42l-3-7.16h1.38l2.25,5.44,1.38-5.44h1.23l2.28,5.48,1.36-5.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.87,246.14a.7.7,0,0,1,.75-.77.85.85,0,0,1,.88.74.71.71,0,0,1-.75.8A.86.86,0,0,1,153.87,246.14Zm.32,1.67h1.27l.48,5.46h-1.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.88,253a1.92,1.92,0,0,1-1.2.36,1.85,1.85,0,0,1-2-1.84l-.23-2.63h-.9l-.09-1h.9l-.11-1.25h1.28l.11,1.25h1.46l.09,1h-1.46l.22,2.6a.78.78,0,0,0,.83.82,1.09,1.09,0,0,0,.7-.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.06,250.14l.28,3.13h-1.28l-.26-3c-.09-1-.61-1.45-1.43-1.45s-1.47.56-1.38,1.65l.24,2.76H162l-.67-7.59h1.28l.24,2.76a2.23,2.23,0,0,1,1.76-.69A2.35,2.35,0,0,1,167.06,250.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7,245.68l.66,7.59h-1.23l-.06-.7a2,2,0,0,1-1.74.77,3,3,0,0,1-3-2.8,2.55,2.55,0,0,1,4.34-2l-.24-2.81Zm-.84,4.86a1.77,1.77,0,0,0-1.77-1.71,1.45,1.45,0,0,0-1.48,1.71,1.77,1.77,0,0,0,1.78,1.71A1.43,1.43,0,0,0,172.86,250.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.72,247.75l.1,1.22a1.77,1.77,0,0,0-.3,0c-1,0-1.53.58-1.44,1.69l.24,2.65H176l-.48-5.46h1.22l.07.8A1.94,1.94,0,0,1,178.72,247.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.54,250.07l.28,3.2h-1.2l-.06-.66a1.78,1.78,0,0,1-1.66.73,2,2,0,0,1-2.17-1.63c-.08-.91.47-1.63,2.12-1.63h1.42V250c-.07-.75-.56-1.19-1.47-1.19a2.51,2.51,0,0,0-1.6.54l-.59-.93a3.61,3.61,0,0,1,2.26-.67A2.36,2.36,0,0,1,184.54,250.07Zm-1.14,1.49-.06-.63H182c-.87,0-1.08.33-1,.73s.45.75,1.11.75A1.26,1.26,0,0,0,183.4,251.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4,247.81l-1.54,5.46h-1.23l-1.74-3.76-1.1,3.76h-1.23l-2.48-5.46h1.21l1.79,4,1.15-4h1.08l1.83,4.05,1.12-4.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.67,283.57l.25,2.89H136.4l-.26-2.87-3.68-5.33h1.62l2.76,4,2.07-4h1.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5,283.33a2.84,2.84,0,0,1,3-3.2,3.49,3.49,0,0,1,3.62,3.2,2.84,2.84,0,0,1-3,3.21A3.5,3.5,0,0,1,140.5,283.33Zm5.19,0a2,2,0,0,0-2-1.95,1.65,1.65,0,0,0-1.68,1.95,2,2,0,0,0,2,2A1.65,1.65,0,0,0,145.69,283.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36,280.2l.55,6.26h-1.4l-.07-.79a2.34,2.34,0,0,1-1.94.87,2.73,2.73,0,0,1-2.93-2.76l-.32-3.58h1.47l.29,3.38c.1,1.14.69,1.67,1.61,1.67s1.66-.63,1.55-1.88l-.28-3.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,280.13l.12,1.4a1.48,1.48,0,0,0-.34,0c-1.11,0-1.76.66-1.65,1.94l.27,3h-1.47l-.54-6.26h1.39l.08.92A2.24,2.24,0,0,1,159.9,280.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.42,278.26h1.52l.72,8.2h-1.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.58,282.88l.32,3.58h-1.47l-.3-3.4c-.09-1.11-.69-1.65-1.63-1.65s-1.69.63-1.58,1.89l.28,3.16h-1.47l-.55-6.26h1.4l.07.81a2.51,2.51,0,0,1,2.08-.88A2.71,2.71,0,0,1,174.58,282.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,283.33a2.87,2.87,0,0,1,3.11-3.2,3.11,3.11,0,0,1,2.8,1.46l-1.07.65a2,2,0,0,0-1.63-.86,1.66,1.66,0,0,0-1.73,1.95,2,2,0,0,0,2.07,2,1.59,1.59,0,0,0,1.48-.87l1.18.66a2.55,2.55,0,0,1-2.54,1.46A3.53,3.53,0,0,1,176,283.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.75,283.33a2.85,2.85,0,0,1,3.05-3.2,3.51,3.51,0,0,1,3.62,3.2,2.85,2.85,0,0,1-3.06,3.21A3.51,3.51,0,0,1,182.75,283.33Zm5.19,0a2,2,0,0,0-2-1.95,1.64,1.64,0,0,0-1.68,1.95,2,2,0,0,0,2,2A1.64,1.64,0,0,0,187.94,283.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.25,282.88l.32,3.58H200.1l-.3-3.4c-.09-1.11-.66-1.65-1.55-1.65s-1.57.63-1.46,1.88l.28,3.17H195.6l-.29-3.4c-.1-1.11-.67-1.65-1.56-1.65s-1.57.63-1.46,1.88l.28,3.17H191.1l-.54-6.26H192l.07.8a2.38,2.38,0,0,1,2-.87,2.55,2.55,0,0,1,2.2,1.05,2.85,2.85,0,0,1,5.06,1.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.13,283.8h-4.91a2.1,2.1,0,0,0,2.16,1.5,2,2,0,0,0,1.64-.68l.87.9a2.92,2.92,0,0,1-2.43,1,3.52,3.52,0,0,1-3.74-3.21,2.81,2.81,0,0,1,2.95-3.2,3.39,3.39,0,0,1,3.45,3.24C209.13,283.49,209.13,283.66,209.13,283.8Zm-5-1h3.55a1.9,1.9,0,0,0-1.91-1.52A1.55,1.55,0,0,0,204.13,282.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "148.06 229.43 141.11 229.43 116.66 344.5 123.6 344.5 148.06 229.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.64 344.5 134.1 229.43 108.02 229.43 83.56 344.5 109.64 344.5",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.76,408.36v1.91a1.88,1.88,0,0,0,1.88,1.88h61.75a1.8,1.8,0,0,0,1.79-1.8v-2a1.8,1.8,0,0,0-1.79-1.8H189.84a3.11,3.11,0,0,1-.69-.07H146.64A1.88,1.88,0,0,0,144.76,408.36Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.06,406.48h57.09a3.39,3.39,0,0,1-2.7-3.24H133.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.6 263.68 194.58 263.68 197.7 255.73 203.6 263.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.21 269.12 199.1 269.12 197.22 258.35 199.32 258.35 201.21 269.12",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.41,375.14l-2.91.27c-.43,0-.43-.64,0-.68l2.91-.27c.43,0,.43.64,0,.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.58,384.63l1.72,1.3c.34.25,0,.84-.34.58l-1.72-1.29c-.34-.26,0-.85.34-.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.87,381l2.85.58c.43.09.25.74-.17.65l-2.85-.58c-.43-.09-.25-.74.17-.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.39,377.81l-1.41-2.1c-.24-.36.34-.7.58-.34l1.41,2.1c.25.36-.34.7-.58.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.59,380.72l2.29.52c.42.09.24.74-.18.65l-2.29-.52c-.42-.09-.25-.74.18-.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,383.53l-2.85.33c-.43.05-.42-.62,0-.67l2.85-.33c.43-.05.43.62,0,.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.24,367.12l-2.13,1c-.39.18-.73-.4-.34-.58l2.13-1c.39-.18.73.4.34.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.66,360c-.35.93-.71,1.86-1.07,2.8-.15.4-.8.23-.65-.18l1.08-2.8c.15-.4.8-.23.64.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.68,380.5H89.12a.34.34,0,0,1,0-.67h2.56a.34.34,0,0,1,0,.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.59,373.85l-2.14-.47c-.42-.09-.24-.74.18-.64l2.14.46c.42.1.24.74-.18.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.87,361.61l-.65-2.24a.33.33,0,0,1,.64-.18l.66,2.24a.34.34,0,0,1-.65.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,388.76s15.4-6.43,10.75-11.92c-4.44-5.23-6.39,6.9-10.75,8.46S109.57,388.76,109.57,388.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,388.76s15.4-6.43,10.75-11.92c-4.44-5.23-6.39,6.9-10.75,8.46S109.57,388.76,109.57,388.76Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.15,392.1s10.47-31.87-8.22-31.37S93.46,394,93.46,394Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.15,392.1s10.47-31.87-8.22-31.37S93.46,394,93.46,394Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.46,394s-3.15-10.13-2.75-19.22c.74,14.75,13.57,14,13.57,14l.88,3.91Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.37,387.57,117,407a5.52,5.52,0,0,1-5.47,4.83H95.71A5.52,5.52,0,0,1,90.24,407l-2.39-19.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.24,387c1.25-7.88,1.05-21.45-9.07-22.85-.72-.1-.41-1.18.29-1.09,10.85,1.5,11.2,15.83,9.86,24.24-.11.71-1.19.41-1.08-.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.23,386.29c.56-6.36-.72-13.59-5-18.48-.47-.54.32-1.34.79-.79,4.5,5.11,5.93,12.6,5.36,19.27-.07.71-1.19.72-1.13,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.77,386.44c-1.3-5.29-2.23-10.68-3-16.07-.11-.7,1-1,1.08-.3.81,5.39,1.74,10.78,3,16.07.17.7-.91,1-1.08.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.79,386.44a37.52,37.52,0,0,1-2.12-15.25c0-.72,1.17-.73,1.13,0a36.57,36.57,0,0,0,2.07,14.95c.25.68-.83,1-1.08.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.79,385c2.32-1.34,5.41-3.45,6-6.21.16-.7,1.24-.4,1.08.3-.7,3.06-4,5.39-6.56,6.87a.56.56,0,0,1-.56-1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.92,378.89l-2.61,3.64c-.42.58-1.39,0-1-.56l2.61-3.65c.42-.58,1.39,0,1,.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.83,363.6s2.35-1,2.43-1.74c.11-1.07-1.86-3.32-2.93-3.19-.9.12-1.68,3.19-1.68,3.19s-.79-3.08-1.69-3.19c-1.18-.13-3.28,2.44-3.11,3.62.09.69,2.34,1.51,2.34,1.51s-2.46,0-2.78.67c-.45.9.63,3.52,1.62,3.71.78.15,2.25-2.22,2.25-2.22s-1.35,2.2-.94,2.82,2.79.91,3.37.3-.48-3.12-.48-3.12,1.28,2.24,2,2.22c1,0,2.83-2.1,2.62-3.09C98.7,364.26,95.83,363.6,95.83,363.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.83,363.6s2.35-1,2.43-1.74c.11-1.07-1.86-3.32-2.93-3.19-.9.12-1.68,3.19-1.68,3.19s-.79-3.08-1.69-3.19c-1.18-.13-3.28,2.44-3.11,3.62.09.69,2.34,1.51,2.34,1.51s-2.46,0-2.78.67c-.45.9.63,3.52,1.62,3.71.78.15,2.25-2.22,2.25-2.22s-1.35,2.2-.94,2.82,2.79.91,3.37.3-.48-3.12-.48-3.12,1.28,2.24,2,2.22c1,0,2.83-2.1,2.62-3.09C98.7,364.26,95.83,363.6,95.83,363.6Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.79,378.77l-2.29-.18c-.43,0-.43-.71,0-.67l2.29.17c.43,0,.43.71,0,.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.11,371l-2.2.5c-.42.09-.6-.55-.17-.65l2.19-.5c.42-.09.6.56.18.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.18,362.93l-1.87,2c-.3.31-.77-.16-.48-.48l1.87-2c.29-.32.77.16.48.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.68,386.41l-3.05.74c-.42.1-.6-.55-.18-.65l3-.74a.34.34,0,0,1,.18.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.23,377.16l-2.2-.55a.34.34,0,0,1,.18-.65l2.2.55c.42.1.24.75-.18.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.59,371.22l-2.14-.45c-.42-.09-.24-.74.18-.65l2.14.45c.42.09.24.74-.18.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.94,361.52v-2a.34.34,0,0,1,.67,0v2a.34.34,0,0,1-.67,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.26,383.57l1.9.52a.33.33,0,0,1-.18.64l-1.9-.51a.34.34,0,0,1,.18-.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.79,385.89l1.94.47c.42.1.24.75-.18.65l-1.94-.47c-.42-.1-.24-.75.18-.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.85,383.07l2.34,1.28c.38.21,0,.79-.34.59l-2.34-1.29c-.38-.21,0-.79.34-.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.41,378.44l2.48-1.36a.33.33,0,0,1,.33.58L119.75,379c-.38.21-.72-.37-.34-.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.13,376.47c.19-.93.38-1.87.56-2.8.09-.42.74-.24.65.18-.18.93-.37,1.86-.56,2.8-.08.42-.73.24-.65-.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,379.18l-1.25-1.3c-.3-.32.18-.79.48-.48l1.25,1.31c.3.31-.18.79-.48.47Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.66,284.36l3-.05a.55.55,0,0,0,.56-.52l-.05-2.86a.55.55,0,0,0-.57-.51l-2.13,0a.56.56,0,0,0-.54.39l-.79,2.87A.54.54,0,0,0,326.66,284.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.57,284.42l3-.05a.55.55,0,0,0,.56-.52l0-2.86a.53.53,0,0,0-.57-.5l-2.12,0a.54.54,0,0,0-.54.39l-.8,2.87A.53.53,0,0,0,322.57,284.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.48,284.48l3-.05a.54.54,0,0,0,.56-.52l-.05-2.85a.53.53,0,0,0-.57-.51l-2.12,0a.54.54,0,0,0-.54.39l-.79,2.87A.52.52,0,0,0,318.48,284.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.39,284.54l3,0a.55.55,0,0,0,.56-.53l-.05-2.85a.54.54,0,0,0-.57-.51l-2.12,0a.57.57,0,0,0-.54.39l-.79,2.87A.52.52,0,0,0,314.39,284.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.3,284.6l3,0a.55.55,0,0,0,.56-.53l0-2.85a.55.55,0,0,0-.58-.51l-2.12,0a.57.57,0,0,0-.54.39l-.79,2.87A.52.52,0,0,0,310.3,284.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.21,284.66l3,0a.55.55,0,0,0,.56-.52l0-2.86a.56.56,0,0,0-.58-.51l-2.12,0a.54.54,0,0,0-.54.39l-.79,2.86A.52.52,0,0,0,306.21,284.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.12,284.73l3-.05a.53.53,0,0,0,.56-.52l0-2.86a.54.54,0,0,0-.58-.5l-2.12,0a.54.54,0,0,0-.54.39l-.79,2.87A.53.53,0,0,0,302.12,284.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,284.79l2.95-.05a.53.53,0,0,0,.56-.52l0-2.86a.54.54,0,0,0-.57-.5l-2.13,0a.55.55,0,0,0-.54.39l-.79,2.87A.53.53,0,0,0,298,284.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,284.85l3,0a.54.54,0,0,0,.55-.53l0-2.85a.53.53,0,0,0-.57-.51l-2.13,0a.57.57,0,0,0-.54.39l-.79,2.87A.53.53,0,0,0,294,284.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.86,284.91l3,0a.54.54,0,0,0,.55-.53l0-2.85a.54.54,0,0,0-.57-.51l-2.13,0a.59.59,0,0,0-.54.39l-.79,2.87A.53.53,0,0,0,289.86,284.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.77,285l3,0a.54.54,0,0,0,.55-.53l0-2.85a.54.54,0,0,0-.57-.51l-2.13,0a.58.58,0,0,0-.54.4l-.79,2.86A.53.53,0,0,0,285.77,285Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.68,285l3-.05a.55.55,0,0,0,.56-.52l-.05-2.86a.55.55,0,0,0-.57-.51l-2.12,0a.54.54,0,0,0-.54.39l-.8,2.87A.54.54,0,0,0,281.68,285Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.59,285.1l3-.05a.55.55,0,0,0,.56-.52l-.05-2.86a.53.53,0,0,0-.57-.5l-2.12,0a.54.54,0,0,0-.54.39l-.79,2.87A.52.52,0,0,0,277.59,285.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.5,285.16l3-.05a.55.55,0,0,0,.56-.52l0-2.86a.53.53,0,0,0-.57-.5l-2.12,0a.54.54,0,0,0-.54.39l-.79,2.87A.53.53,0,0,0,273.5,285.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.41,285.22l3,0a.55.55,0,0,0,.56-.53l0-2.85a.55.55,0,0,0-.58-.51l-2.12,0a.57.57,0,0,0-.54.39l-.79,2.87A.52.52,0,0,0,269.41,285.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.44,285.58a2.37,2.37,0,0,0,2.5,2.21l61.22-.93a2.36,2.36,0,0,0,2.43-2.28,2.16,2.16,0,0,0-.74-1.59,2.66,2.66,0,0,0-1.7-.63l-61.28.93a2.48,2.48,0,0,0-.68.1A2.28,2.28,0,0,0,266.44,285.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.44,285.58a2.37,2.37,0,0,0,2.5,2.21l61.22-.93a2.36,2.36,0,0,0,2.43-2.28,2.16,2.16,0,0,0-.74-1.59,2.66,2.66,0,0,0-1.7-.63l-61.28.93a2.48,2.48,0,0,0-.68.1A2.28,2.28,0,0,0,266.44,285.58Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.44,285.58a2.37,2.37,0,0,0,2.5,2.21l20.73-.32a2.29,2.29,0,0,0,1.67-2.17,1.84,1.84,0,0,0,0-.41,2.17,2.17,0,0,0-.71-1.17,3.34,3.34,0,0,0-.53-.37l-.29-.12a2.49,2.49,0,0,0-.95-.15l-20.63.31A2.28,2.28,0,0,0,266.44,285.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.78 394.71 285.08 393.24 285.52 375.36 295.05 377.7 292.78 394.71",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.78 372.84 285.72 370.21 285.38 382.43 294.32 383.58 295.78 372.84",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.34,282.6s-50.06,8.42-48.09,30.86c0,0-1,22.81-1.11,64l13.1,2s13.43-42.71,11.1-60.44c21.14-3.56,43.43,1.69,52.1-9.22,6.69-8.56,1.62-27.72,1.62-27.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.39 381.94 282.28 379.56 282.33 372.02 300.06 375.39 299.39 381.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.8,392.82l8.74,1.45a.66.66,0,0,1,.52.72l-.47,8.24a1.44,1.44,0,0,1-1.54,1.4c-3-.56-4.48-1-8.32-1.64-2.37-.4-7.79-1.36-11.07-1.63s-3-4.1-1.6-4.34c6.33-1,9.91-2.18,12.33-3.85A1.94,1.94,0,0,1,284.8,392.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.94,394.43a10.23,10.23,0,0,0,2.07,0,.16.16,0,0,0,.15-.12.2.2,0,0,0,0-.2c-.22-.21-2.23-2-3.22-1.76a.66.66,0,0,0-.5.45,1.05,1.05,0,0,0,.1,1A2.13,2.13,0,0,0,280.94,394.43Zm1.66-.33c-1.44,0-2.46-.09-2.77-.5a.65.65,0,0,1,0-.66.33.33,0,0,1,.23-.24C280.56,392.57,281.77,393.4,282.6,394.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,394.43h.08a.21.21,0,0,0,.12-.14c0-.09.5-2.31-.19-3.17a.87.87,0,0,0-.73-.36.69.69,0,0,0-.73.46c-.3.82.65,2.6,1.36,3.17A.13.13,0,0,0,283,394.43Zm-.64-3.3a.55.55,0,0,1,.37.22,4,4,0,0,1,.17,2.53,3.67,3.67,0,0,1-1-2.54c0-.1.11-.22.38-.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.11 398.93 252.51 397.16 255.39 379.44 264.3 382.13 260.11 398.93",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.56 376.76 256.24 373.74 254.49 385.02 262.93 387.36 265.56 376.76",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.31,282.11c-.07,0-2,5.23-5.88,5-32.95-1.7-58.33.11-58.33,20.28-1.63,35.32-3.7,72.71-3.7,72.71L265.75,383s15.4-43,14.32-68.2c28.3,5.86,59.27,7,68.85-7.21,7.13-12.79,1.05-25.17,1.05-25.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.25 385.35 252.03 381.5 253.16 374.61 268.69 379.37 267.25 385.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.06,392.86l8.77,1.54a.72.72,0,0,1,.51.79l-.4,9.05c-.09,1-.78,1.68-1.54,1.56h0c-3-.61-4.47-1.1-8.32-1.77-2.37-.41-8.83-1.77-12.09-2.52s-2.66-4.88-1.18-4.95c6.38-.29,10.49-1.47,12.89-3.33A1.75,1.75,0,0,1,253.06,392.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.54,394.92a9.51,9.51,0,0,0,1.66-1.23.17.17,0,0,0-.1-.31c-.3,0-3-.3-3.64.49a.67.67,0,0,0-.12.65,1,1,0,0,0,.68.78A2.16,2.16,0,0,0,249.54,394.92Zm1.13-1.24c-1.1.91-2,1.37-2.52,1.23a.65.65,0,0,1-.41-.53.29.29,0,0,1,0-.31C248.15,393.68,249.59,393.61,250.67,393.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.2,393.69l.08-.05a.17.17,0,0,0,0-.17c-.06-.07-1-2.16-2-2.45a.88.88,0,0,0-.8.15.69.69,0,0,0-.32.8c.25.85,2.06,1.71,3,1.75A.11.11,0,0,0,251.2,393.69Zm-2.47-2.27a.54.54,0,0,1,.43-.06,4.14,4.14,0,0,1,1.65,1.95,3.74,3.74,0,0,1-2.33-1.45c-.06-.09,0-.25.18-.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Character--inject-578--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.18,211c1.52,4,2.73,8.11-3.06,10.23,0,0-6.34,9.62,3.58,22.33,5.26-7.56,10.57-15.67,13.95-24.24-2.42-1.83-3.38-5.29-3.68-8.94a3.89,3.89,0,0,0-6.21-2.82Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.87,192.52c-.48,0-.9.54-.93,1.27s.32,1.34.8,1.36.89-.51.93-1.27S331.34,192.54,330.87,192.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.85,200.15a3.16,3.16,0,0,1-2.44-1.05,18.89,18.89,0,0,0,3.55-4Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.17,189.69a3.41,3.41,0,0,1,2.74,1.45.25.25,0,0,0,0,.07.44.44,0,0,0,.6.1.43.43,0,0,0,.09-.6,4.24,4.24,0,0,0-3.43-1.88.43.43,0,0,0-.45.41.46.46,0,0,0,.2.38A.48.48,0,0,0,331.17,189.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.39,192.53c-1,8.92-1.25,12.72-6,17.08a12.63,12.63,0,0,1-9.21,3.47s-.05,0-.06,0a11.66,11.66,0,0,1-3-.56,11.8,11.8,0,0,1-2.36-1.1h0a10.89,10.89,0,0,1-5-7.46c-1.51-8.15.4-21.37,9.34-24.48a12.25,12.25,0,0,1,16.25,13.06Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45,179.15c-3.22-1.37-6.87-1.27-10.35-.91s-7,1-10.46.62c-1.29-.13-2.45-1.45-4.23-.1-2.32,1.76-1.15,9.23,4.33,7.92,6-1.44,3,5.43,3,6.54a6,6,0,0,0,1.18,2.44c2.37,5.24,6.27,13.09,7.41,15.55a20.3,20.3,0,0,0,6.4-.26C355.75,204.17,366.52,184.73,353.45,179.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.39,193.09c-2.19.5-3,3.56-2.85,5.52.15,2.18,1.88,3.65,3.74,2.29a6.56,6.56,0,0,0,2.59-4.29A2.94,2.94,0,0,0,338.39,193.09Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.11,213.08a11.66,11.66,0,0,1-3-.56,11.8,11.8,0,0,1-2.36-1.1h0l0-.07a5.44,5.44,0,0,0,3.45-.19,1.34,1.34,0,0,1,1-.16c.34.13.48.53.58.88S341,212.68,341.11,213.08Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.09,222.33a8.88,8.88,0,0,1,4.93-3.87c3.51-1.14,17-1,18.34,0a7.35,7.35,0,0,1,2.81,3.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.24,277.88c-10.7.71-25.25,2.41-25.93,2.86.14-.29,2.25-4.74-2.19-5.91l25.73-8.26c.06-9.19.21-32,.22-34.19,0-.73,0-1.46,0-2.2a6.25,6.25,0,0,1,5.83-6.32h.42c3.58,0,6.19,3,6.24,6.64C370.89,256.81,372,277.11,360.24,277.88Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.31,280.74h0a.21.21,0,0,1-.26,0c-.84-.54-1.92-5.92-1.92-5.92C336.56,276,334.45,280.45,334.31,280.74Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.31,280.74H334l-9.36-.09-6.23.78a2.11,2.11,0,0,1-2.38-2.1v0a2.12,2.12,0,0,1,.83-1.64l5.83-4.48a2.08,2.08,0,0,1,1.82-.36l7.57,2C336.56,276,334.45,280.45,334.31,280.74Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.85,238.49a52.19,52.19,0,0,0,4.93,9l6.7-4.72a24.29,24.29,0,0,0-2.3-3.56C364,235.63,360.54,236.41,357.85,238.49Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.19,229c-3.12,4.34-.1,16.84-.1,16.84l16.12-4s-.16-15.12-3.43-17.82C366.06,220.87,360.39,224.44,357.19,229Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M357.19,229c-3.12,4.34-.1,16.84-.1,16.84l16.12-4s-.16-15.12-3.43-17.82C366.06,220.87,360.39,224.44,357.19,229Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M335.92,220.1a126.61,126.61,0,0,1,18.06.47,107.35,107.35,0,0,1,11.15,1.49l.34.08a5.41,5.41,0,0,1,3.93,6.57c-7.23,28.7-7.43,38.44-7.2,53.72l-39.76-1.06c-.86-6.38-.66-48.9-.14-53.68C321.47,221.06,331.07,220.41,335.92,220.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.91,279.75l-39.5-1.06c-.39,0-.71.2-.68.44l-.47,3.28c0,.6.26.79.62.8l40.39.9c.45,0,.79-.26.65-.55l-.35-3.5A.74.74,0,0,0,361.91,279.75Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.15,269c-5.29,3.65-25.09,11.28-25.77,11.73.14-.29,2.25-4.74-2.19-5.91L315,260.71a10.16,10.16,0,0,0,3.84-7.81c.11-7.82.32-18.72.33-20.52,0-.73,0-1.46,0-2.2a6.25,6.25,0,0,1,5.83-6.32h.42c3.58,0,6.19,3,6.24,6.64C332,256.81,330.86,262.3,321.15,269Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.38,280.74h0a.21.21,0,0,1-.26,0c-.84-.54-1.92-5.92-1.92-5.92C297.63,276,295.52,280.45,295.38,280.74Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.38,280.74h-.27l-9.36-.09-6.23.78a2.11,2.11,0,0,1-2.38-2.1v0a2.12,2.12,0,0,1,.83-1.64l5.83-4.48a2.08,2.08,0,0,1,1.82-.36l7.57,2C297.63,276,295.52,280.45,295.38,280.74Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27,223.07c-6,2.58-5.33,10.54-5,21.13,11.94-2.8,16.43-.34,16.31,0,.54-3.52,2.32-13.11-2.4-19A7,7,0,0,0,322.27,223.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.94,324.39c-8.34,0-16.24,2.07-22.13,6.84a55,55,0,0,1-1.16-15.68c.17-2.44.65-5.11,2.82-6.6,2.67-1.83,6.95-1.06,9.75.91s4.5,4.86,6.09,7.64C298.53,319.63,300.12,322.57,301.94,324.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.4,308.12s7.82,1.09,12.6,11.45c0,0,3.55-2.84,6.9-3C302.9,316.56,292.15,305.08,283.4,308.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.94,324.39c-8.34,0-16.24,2.07-22.13,6.84a55,55,0,0,1-1.16-15.68c.17-2.44.65-5.11,2.82-6.6,2.67-1.83,6.95-1.06,9.75.91s4.5,4.86,6.09,7.64C298.53,319.63,300.12,322.57,301.94,324.39Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.94,333.23a4,4,0,1,1-5.47-1.13A4,4,0,0,1,276.94,333.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.94,333.23a4,4,0,1,1-5.47-1.13A4,4,0,0,1,276.94,333.23Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.17,412.57a22.34,22.34,0,0,1-9-1.42,5.81,5.81,0,0,1-3.5-4.82L290,390.57c2.63-2.27,18.94-2.36,22.7,5.44,0,0-1,3.56-2.86,11.14C308.57,412.34,307.16,412.44,304.17,412.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.17,412.57a22.34,22.34,0,0,1-9-1.42,5.81,5.81,0,0,1-3.5-4.82L290,390.57c2.63-2.27,18.94-2.36,22.7,5.44,0,0-1,3.56-2.86,11.14C308.57,412.34,307.16,412.44,304.17,412.57Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.39,414.07a22.09,22.09,0,0,1-9.15-.4,5.77,5.77,0,0,1-4-4.39l-2.74-12.57c1.23-3.45,14.43-6.88,22.74-.48,0,0-1,8.37-1.8,11.82C398.55,411.89,397.34,413.61,394.39,414.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.39,414.07a22.09,22.09,0,0,1-9.15-.4,5.77,5.77,0,0,1-4-4.39l-2.74-12.57c1.23-3.45,14.43-6.88,22.74-.48,0,0-1,8.37-1.8,11.82C398.55,411.89,397.34,413.61,394.39,414.07Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.91,400.5c-47.62-5-58.49-10.75-74.93-16.46-10-3.45-22.53-6.37-27.65-15.59-3.54-6.38-4.65-18.14,2.13-20.83a154.64,154.64,0,0,0,35.25-19.73c5.51-4.11,10.81-8.63,17.07-11.47s20.84-4.27,33.19,1.82c14.92-1.54,47.61-10.41,78-.6,14.27,4.61,24.67,19.24,26.26,34.16,1.62,15.21-3.58,28.8-15.21,38.74S361.12,402.1,345.91,400.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,320.86c-9.77-2.61-26-5.41-37.85-3.76-1.58-1-4.21-2.2-5.79-3.15,14.28-1.22,25.88,1.23,34.6,3.12C404.93,317.07,412.5,319.87,414,320.86Z",
    style: {
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.41,338a3.95,3.95,0,1,1-4-3.95A4,4,0,0,1,305.41,338Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.66,413.34a22.27,22.27,0,0,1-9.14.49,5.81,5.81,0,0,1-4.43-4L406.17,377c2.1-2.77,9.14-5.2,15.32-3.86,3.44.75,8.48,2.53,8.26,6s-.6,11.95-1.66,27.79C427.73,412.19,426.55,412.59,423.66,413.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.85,415.48a22.05,22.05,0,0,1-9.15,0,5.77,5.77,0,0,1-4.18-4.23l-3.3-28.72c2.26-2.64,9.42-4.66,15.52-2.95,3.39.95,8.31,3,7.89,6.43s-1.8,19.76-2,23.3C344.39,414.61,342.79,414.9,339.85,415.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.89,310.28a15.22,15.22,0,0,1,11.54,12.28c1.87,10.46-14.87,23-14.87,23S349.63,333.71,339.89,310.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.89,310.28a15.22,15.22,0,0,1,11.54,12.28c1.87,10.46-14.87,23-14.87,23S349.63,333.71,339.89,310.28Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.49,342.55a26.7,26.7,0,0,0-14.69-22.47c3-4.46,7.18-10.62,12.54-11.08,4.24-.36,8.33,2.42,10.36,6.16s2.27,8.21,1.59,12.41a31.34,31.34,0,0,1-9.73,18C336.84,345.27,336.21,342.88,336.49,342.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.49,342.55a26.7,26.7,0,0,0-14.69-22.47c3-4.46,7.18-10.62,12.54-11.08,4.24-.36,8.33,2.42,10.36,6.16s2.27,8.21,1.59,12.41a31.34,31.34,0,0,1-9.73,18C336.84,345.27,336.21,342.88,336.49,342.55Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,360.1c0,4.16-.73,7.52-1.62,7.52s-1.63-3.36-1.63-7.52.73-7.53,1.63-7.53S249,355.94,249,360.1Z",
    style: {
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.08,
    cy: 360.1,
    rx: 1.62,
    ry: 7.53,
    style: {
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,379.09c.8.09,10.86-1.23,14.88-4.29s.68,3.71-8.76,4.86A12.27,12.27,0,0,1,264.77,379.09Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.48,169.49c-.65-8.26-5.68-15.11-14.92-15.26L352.4,164.68A16.82,16.82,0,0,1,366,178.19c1.51,9.23,6.33,19.42,14.79,23.38,7.66-2.64,25-10.66,25.43-10.84C402.66,188.55,391.53,182.8,390.48,169.49Zm-34.06-5s0-.1,0-.13l.15,0Zm43,26.47c-3.82,1.73-11.07,5-16.14,6.93a4.11,4.11,0,0,0-4.4-.13c-7.17-4.93-9.81-14-11.24-21.76-.86-4.6-3.59-8.93-7.66-10.82a1.35,1.35,0,0,0,.16-1.07,1.3,1.3,0,0,0-.76-.84l14.73-6.75a5.88,5.88,0,0,0,3.67-.55c6.57,1.26,10.74,8,10.92,12.65A24.84,24.84,0,0,0,399.13,188,3.42,3.42,0,0,0,399.45,191Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.42,164.52s0-.1,0-.13l.15,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.45,191c-3.82,1.73-11.07,5-16.14,6.93a4.11,4.11,0,0,0-4.4-.13c-7.17-4.93-9.81-14-11.24-21.76-.86-4.6-3.59-8.93-7.66-10.82a1.35,1.35,0,0,0,.16-1.07,1.3,1.3,0,0,0-.76-.84l14.73-6.75a5.88,5.88,0,0,0,3.67-.55c6.57,1.26,10.74,8,10.92,12.65A24.84,24.84,0,0,0,399.13,188,3.42,3.42,0,0,0,399.45,191Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.45,191c-3.82,1.73-11.07,5-16.14,6.93a4.11,4.11,0,0,0-4.4-.13c-7.17-4.93-9.81-14-11.24-21.76-.86-4.6-3.59-8.93-7.66-10.82a1.35,1.35,0,0,0,.16-1.07,1.3,1.3,0,0,0-.76-.84l14.73-6.75a5.88,5.88,0,0,0,3.67-.55c6.57,1.26,10.74,8,10.92,12.65A24.84,24.84,0,0,0,399.13,188,3.42,3.42,0,0,0,399.45,191Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.64,174.64a.53.53,0,0,0-.34.33,1.77,1.77,0,0,0-.07.65l1.44-.49a1.18,1.18,0,0,0-.5-.46A.7.7,0,0,0,380.64,174.64Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.87,177.21l-1.4.47a1.2,1.2,0,0,0,.47.46.63.63,0,0,0,.5,0,.53.53,0,0,0,.35-.32A1.72,1.72,0,0,0,378.87,177.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.09,173.78a8.46,8.46,0,0,0-10.57-4.88,7.54,7.54,0,0,0-4.52,10,8.45,8.45,0,0,0,10.57,4.87A7.54,7.54,0,0,0,387.09,173.78Zm-9.56,5.84a3.19,3.19,0,0,1-1.39-1.48l-1.13.38c-.13-.34-.26-.67-.38-1l1.1-.37a5.79,5.79,0,0,1-.27-1.51,3.7,3.7,0,0,1,.13-1.26l1.45.13a3.86,3.86,0,0,0-.14,1.05,4,4,0,0,0,.16,1.14l1.69-.57a7.2,7.2,0,0,1-.07-1.34,2.18,2.18,0,0,1,.31-1,1.69,1.69,0,0,1,1-.7,2.12,2.12,0,0,1,1.67.12,3.2,3.2,0,0,1,1.4,1.51l1.12-.38.37,1-1.1.38a4.64,4.64,0,0,1,.16,2.24l-1.44-.08a4.25,4.25,0,0,0-.05-1.71l-1.72.58a9.36,9.36,0,0,1,.08,1.32,2.14,2.14,0,0,1-.31,1,1.68,1.68,0,0,1-.95.7A2.12,2.12,0,0,1,377.53,179.62Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.49,155.37a1.74,1.74,0,0,1-.29-.07c-1.87-.63-4.71-3.55-7.14-7.53s-3.71-7.86-3.39-9.82h0a1.77,1.77,0,0,1,.38-.91s0,0,0,0a.87.87,0,0,1,.23-.2,1.3,1.3,0,0,1,.3-.13,1.79,1.79,0,0,1,1,.08,4.7,4.7,0,0,1,1.15.57,9.14,9.14,0,0,1,.83.61c.16.13.33.27.49.42a27.17,27.17,0,0,1,4.72,6,26.81,26.81,0,0,1,3.1,6.9q.09.35.15.66a6.88,6.88,0,0,1,.17,1.1,4.2,4.2,0,0,1,0,1.25,1.56,1.56,0,0,1-.44.9.58.58,0,0,1-.19.15.72.72,0,0,1-.2.09A1.48,1.48,0,0,1,344.49,155.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.49,155.37l-.15-.25-5.24-8.63c-.14-.23-.28-.45-.4-.67l-4.9-8h0a1.91,1.91,0,0,1,.25-.73,1.46,1.46,0,0,1,.16-.21l.53-.33,1.61-1,.72,1.19.13.21.5.83.36.6,7.82,12.85.29.48.55.9.12.22.73,1.18-1.85,1.13-.39.24A1.48,1.48,0,0,1,344.49,155.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.35,135.52c-1.58,1-.35,5.88,2.75,11S346,155,347.57,154s.35-5.87-2.75-11S337.93,134.56,336.35,135.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.35,135.52c-1.58,1-.35,5.88,2.75,11S346,155,347.57,154s.35-5.87-2.75-11S337.93,134.56,336.35,135.52Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.17,136.63a.62.62,0,0,0-.22.26c1.31,0,4.07,2.91,6.52,7s3.77,7.83,3.16,9a.62.62,0,0,0,.33-.08c1.07-.65-.23-4.8-2.94-9.25S338.24,136,337.17,136.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.17,136.63a.62.62,0,0,0-.22.26c1.31,0,4.07,2.91,6.52,7s3.77,7.83,3.16,9a.62.62,0,0,0,.33-.08c1.07-.65-.23-4.8-2.94-9.25S338.24,136,337.17,136.63Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,136.89c-.6,1.16.71,5,3.16,9s5.22,7,6.52,7c.61-1.16-.7-5-3.16-9S338.26,136.89,337,136.89Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.61,132.83c4.6,1.61,6,8.15,2.36,14.37s-10,8.31-13.69,5.15c-3.19-2.73-3.24-8.53-.47-13.29S238.65,131.44,242.61,132.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,132.25c4.33,1.52,5.52,7.8,2,13.82s-9.57,8.12-13.05,5.15c-3-2.58-3-8.19-.3-12.83S237.22,130.94,241,132.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,132.25c4.33,1.52,5.52,7.8,2,13.82s-9.57,8.12-13.05,5.15c-3-2.58-3-8.19-.3-12.83S237.22,130.94,241,132.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.46,134.58a3.71,3.71,0,0,1,.53.25s0,0,0,0c2.61,1.58,3.07,5.9.73,9.93s-6.34,5.8-9,4.34c0,0,0,0,0,0a4.81,4.81,0,0,1-.49-.34c-2.35-1.83-2.42-6.09-.34-9.66S236.69,133.46,239.46,134.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,134.83s0,0,0,0c2.61,1.58,3.07,5.9.73,9.93s-6.34,5.8-9,4.34c0,0,0,0,0,0-2-2.1-1.92-6.1.06-9.5S237.19,134.18,240,134.83Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.73,222c2.18,4.44-.45,10.19-5.87,12.86s-11.59,1.23-13.77-3.21.46-10.19,5.88-12.85S415.55,217.55,417.73,222Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.86,220.22c2.18,4.43-.45,10.19-5.87,12.85s-11.58,1.23-13.76-3.2.45-10.19,5.87-12.86S414.68,215.78,416.86,220.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.86,220.22c2.18,4.43-.45,10.19-5.87,12.85s-11.58,1.23-13.76-3.2.45-10.19,5.87-12.86S414.68,215.78,416.86,220.22Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.34,221.28c.1.22.19.43.27.64,0,0,0,0,0,.05,1.06,3.23-.92,7.09-4.69,8.95s-8.06,1.07-10-1.75c0,0,0,0,0,0-.11-.19-.23-.39-.34-.6-1.63-3.32.35-7.64,4.41-9.64S412.7,218,414.34,221.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.61,221.92s0,0,0,.05c1.06,3.23-.92,7.09-4.69,8.95s-8.06,1.07-10-1.75c0,0,0,0,0,0-1.06-3.22.92-7.1,4.71-9S412.7,219.12,414.61,221.92Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.32,125.18l-21,11c-7.37-5-13.56-5.6-21-.73a54.78,54.78,0,0,1-7.42,3.76,40.57,40.57,0,0,1-5.2,1.92,9.37,9.37,0,0,1-9.43-3.11c9.57-4.77,13.83-8.46,23.39-13.22,1.54,2.51,4.45,2.53,7.49,1.64,4.23-1.25,8.71-4.28,10.05-4.82A23.53,23.53,0,0,1,321.32,125.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.22,124.86c-6.34-5.19-15.27-3.35-19.5-1.68-2.31.91-13.93,8.37-17.45,3.19-9.57,4.76-10.33,6.83-19.9,11.59,1.53,1.29,5.86,4.14,15.54-2.64,7.28-5.1,16.73-6.11,24.1-1.14C306.68,130.69,310.54,128.34,317.22,124.86Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.85,136.69c-.74.45-1.4.94-2.13,1.39l2.45,1.27A2,2,0,0,0,261.85,136.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,127.18a2.93,2.93,0,0,1-3.13-.54,3.8,3.8,0,0,1,1.65-1A8.13,8.13,0,0,0,282,127.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.92,133.38a4.33,4.33,0,0,0-4.49.4l1.78,1.06A6.08,6.08,0,0,1,302.92,133.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.14,124.89a7.66,7.66,0,0,0-3.2,1.59,1.87,1.87,0,0,1,.65-2.76A12.82,12.82,0,0,1,319.14,124.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.13,126.42c-1.11,1.64-12,9.67-16.25,12.77a40.57,40.57,0,0,1-5.2,1.92,9.37,9.37,0,0,1-9.43-3.11c9.57-4.77,13.83-8.46,23.39-13.22C282.18,127.29,285.09,127.31,288.13,126.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.24,131.54c.21.59,4-.29,8.44-1.95s7.87-3.47,7.65-4-4,.29-8.44,1.95S281,131,281.24,131.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.45,311.93c-9.79-22.4,17.87-39.94,8.08-62.34l34.67,4.49c9.79,22.4-17.87,39.95-8.08,62.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.8,309.65l23.77,3.08a1.76,1.76,0,0,1,2-2.44c-3.14-17.84,14.75-33,11.6-50.79a4.44,4.44,0,0,1-3.31-3.14l-23.77-3.08a1.76,1.76,0,0,1-2,2.45c3.14,17.84-14.75,33-11.6,50.79A4.42,4.42,0,0,1,378.8,309.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.46,281.81a.91.91,0,0,0-.64.17,3.24,3.24,0,0,0-.66.64l1.85.24a1.12,1.12,0,0,0-.06-.75A.64.64,0,0,0,398.46,281.81Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.35,283.59l-1.8-.24a1.11,1.11,0,0,0,0,.72.58.58,0,0,0,.46.3.9.9,0,0,0,.64-.16A3.08,3.08,0,0,0,394.35,283.59Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.55,284.27c2.38-5.15-.42-9.94-5.83-10.64s-11.24,3-13.62,8.12.43,9.94,5.83,10.64S403.17,289.42,405.55,284.27Zm-14.73,1.15a3,3,0,0,1,0-2.29l-1.46-.19.56-1.25,1.42.18a9.82,9.82,0,0,1,1.13-1.72,7,7,0,0,1,1.3-1.27l1.29.9a6.73,6.73,0,0,0-1.11,1,7.73,7.73,0,0,0-.9,1.27l2.18.29a13.11,13.11,0,0,1,1.16-1.44,4.38,4.38,0,0,1,1.26-.93,2.69,2.69,0,0,1,1.58-.23,1.88,1.88,0,0,1,1.53,1,3.05,3.05,0,0,1,0,2.31l1.45.19c-.19.41-.38.83-.56,1.25l-1.42-.19a8.24,8.24,0,0,1-1.92,2.45L397,286a7.76,7.76,0,0,0,1.53-1.83l-2.22-.29a12.74,12.74,0,0,1-1.14,1.43,4.18,4.18,0,0,1-1.24.92,2.67,2.67,0,0,1-1.57.23A1.81,1.81,0,0,1,390.82,285.42Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.86,315.45a11.7,11.7,0,1,1,15.43-6A11.7,11.7,0,0,1,394.86,315.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.29,316.74a11.71,11.71,0,1,1,15.44-6A11.7,11.7,0,0,1,394.29,316.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.29,316.74a11.71,11.71,0,1,1,15.44-6A11.7,11.7,0,0,1,394.29,316.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,309.57a7.16,7.16,0,0,1-.45.87,8.71,8.71,0,1,1,.45-.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,309.57a7.16,7.16,0,0,1-.45.87,8.76,8.76,0,0,1-14.92-8.93,7.91,7.91,0,0,1,.42-.82A8.76,8.76,0,0,1,407,309.57Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.76,308.8c-1.91-.47-2.55-2.21-1.77-4.49l-1.45-.68.59-1.33,1.45.68a8,8,0,0,1,2.45-2.79l1.39,1.33a6.61,6.61,0,0,0-2.13,2.27l2.22,1c.95-1.14,2.08-2.37,3.82-1.94,1.9.47,2.55,2.25,1.73,4.55l1.45.69-.59,1.33-1.46-.69a7.35,7.35,0,0,1-1.9,2.25l-1.42-1.25a5.93,5.93,0,0,0,1.62-1.8l-2.32-1.09C398.51,308,397.41,309.21,395.76,308.8Zm4.64-3.08,1.89.9c.18-.8-.07-1.34-.61-1.49S400.83,305.29,400.4,305.72Zm-4.06.83c.42.1.81-.14,1.2-.56l-1.8-.85C395.58,305.9,395.8,306.41,396.34,306.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,178.3A10.61,10.61,0,1,1,207.82,182,10.6,10.6,0,0,1,193.29,178.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,179a10.61,10.61,0,1,1,14.54,3.72A10.62,10.62,0,0,1,192.19,179Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,179a10.61,10.61,0,1,1,14.54,3.72A10.62,10.62,0,0,1,192.19,179Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.36,180.37a7.37,7.37,0,0,1-.79.41,7.94,7.94,0,0,1-7.29-14.07A7.35,7.35,0,0,1,199,166a7.93,7.93,0,0,1,6.35,14.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.36,180.37a7.37,7.37,0,0,1-.79.41,7.94,7.94,0,0,1-6.3-14.45A6.49,6.49,0,0,1,199,166a7.93,7.93,0,0,1,6.35,14.42Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.46,173.87c-1.16-1.36-.72-3,1-4.25l-.71-1.27,1.14-.67.71,1.27a7.2,7.2,0,0,1,3.28-.76l.32,1.71a5.94,5.94,0,0,0-2.76.55l1.08,1.94c1.3-.34,2.78-.65,3.84.59s.7,3-1.12,4.26l.71,1.27-1.14.67-.72-1.27a6.55,6.55,0,0,1-2.58.65l-.39-1.67a5.06,5.06,0,0,0,2.14-.47l-1.13-2C199.9,174.74,198.46,175,197.46,173.87Zm5,.17.93,1.66c.55-.5.64-1,.32-1.42S203,174,202.5,174Zm-3.43-1.53a1.14,1.14,0,0,0,1.18.22l-.88-1.57C198.85,171.63,198.74,172.12,199.07,172.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.63,239.66C200,222.46,186,205.22,202.29,188L174.17,188c-16.34,17.2-2.31,34.45-18.65,51.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.23,237.34l-19.27,0c1-1.21.64-2.2-.54-2.2,9.48-14.19,1.91-28.42,11.39-42.61a5.65,5.65,0,0,0,3.76-2.19l19.27,0c-1,1.21-.64,2.2.55,2.2-9.48,14.19-1.91,28.42-11.39,42.61A5.62,5.62,0,0,0,181.23,237.34Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.38,212.56a.49.49,0,0,1,.42.21,1.73,1.73,0,0,1,.25.59h-1.51a1.31,1.31,0,0,1,.35-.61A.7.7,0,0,1,177.38,212.56Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.79,214.44h1.46a1.19,1.19,0,0,1-.32.58.63.63,0,0,1-.46.19.48.48,0,0,1-.42-.2A1.5,1.5,0,0,1,179.79,214.44Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.13,221.87a8.8,8.8,0,0,0,8.66-8c.24-4.45-2.79-8.07-7.12-8.07a8.78,8.78,0,0,0-8.65,8C170.77,218.25,173.8,221.87,178.13,221.87Zm2.08-4.91a1.6,1.6,0,0,1-1.1-.36,2,2,0,0,1-.58-.88,7.68,7.68,0,0,1-.29-1.28h-1.8a4.13,4.13,0,0,0,.43,1.65l-1.34.54a4.85,4.85,0,0,1-.49-2.19h-1.15c0-.36.05-.72.07-1.08h1.18a3.27,3.27,0,0,1,.9-1.89,2.19,2.19,0,0,1,1.55-.65,1.59,1.59,0,0,1,1.11.36,2.11,2.11,0,0,1,.59.89,8.77,8.77,0,0,1,.31,1.29h1.76a4,4,0,0,0-.17-1.14,3.53,3.53,0,0,0-.43-1l1.34-.59a3.59,3.59,0,0,1,.48,1.16,5.94,5.94,0,0,1,.17,1.53h1.15c0,.36-.05.72-.07,1.08h-1.18a3.54,3.54,0,0,1-.9,1.87A2.16,2.16,0,0,1,180.21,217Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIncomeRafiki);
export default __webpack_public_path__ + "static/media/money-income-rafiki.fc6c2ac033440c5328e89c3e3e094604.svg";
export { ForwardRef as ReactComponent };